<ng-template [ngIf]="!loaded" [ngIfElse]="loading">




  <div class="row  justify-content-center">
    <h2 class="col-12 titleBookk bold">{{ 'PAYMENT.TITLE' | translate }}</h2>

    <mat-card class="col-11 col-md-6">

      <div class="row justify-content-center">
        <div class="">
          <p>{{ 'PAYMENT.INFO.TITLE' | translate }}</p>
        </div>
      </div>


      <div *ngIf="paymode ==='direct' && card.month !== null" class="row justify-content-center mt-3">
        <div class="col-sm-auto col-12 row justify-content-center">
          <mat-icon style="width: 40px" aria-hidden="false" svgIcon="paiement"></mat-icon>
          <label class="ml-3">{{card.brand}} {{ 'PAYMENT.INFO.CARD1' | translate }} {{card.last4}}</label>
        </div>
      </div>

      <div *ngIf="paymode ==='direct' && card.month !== null" class="row justify-content-center mt-4 mb-2">
        <label class="ml-3">{{ 'PAYMENT.INFO.CARD2' | translate }} : {{card.month  |  number: '2.0-0' }}/{{card.year}}</label>
      </div>

      <div *ngIf="paymode ==='paydebit'" class="row justify-content-center mt-4 mb-2">
        <div class="col-sm-auto col-11 row justify-content-center">
          <label class="ml-3">{{ 'PAYMENT.INFO.PAYDEBIT' | translate }}</label>
        </div>
      </div>

      <div *ngIf="paymode ==='prepaid'" class="row justify-content-center mt-4 mb-2">
        <div class="col-sm-auto col-11 row justify-content-center">
          <label class="ml-3">{{ 'PAYMENT.INFO.PREPAID' | translate }}</label>
        </div>
      </div>

      <div *ngIf="paymode ==='transfer'" class="row justify-content-center mt-4 mb-2">
        <div class="col-sm-auto col-11 row justify-content-center">
          <label class="ml-3">{{ 'PAYMENT.INFO.TRANSFER' | translate }}</label>
        </div>
      </div>

      <div *ngIf="paymode ==='direct' && card.month === null" class="row justify-content-center mt-4 mb-2">
        <label class="ml-3">{{ 'PAYMENT.INFO.CARD3' | translate }}</label>
      </div>

      <div *ngIf="paymode ==='direct'" class="row justify-content-center mt-4 mb-2">
        <!-- <button class="col-7 col-sm-11"  mat-raised-button  color="primary">Modifier</button> -->
        <a class="col-11 col-sm-10 bold" mat-raised-button color="primary" [href]="userPaieFormu"
          target="_blank">{{ 'PAYMENT.INFO.CARD4' | translate }}</a>
      </div>


    </mat-card>


  </div>


  <!-- table -->
  <div class="row  justify-content-center mt-5">

    <mat-card class="col-11 col-md-6">
      <div class="row justify-content-center">
        <div class="">
          <p>{{ 'PAYMENT.FACTURATION.TITLE' | translate }}</p>
        </div>
      </div>
      <app-facture-list></app-facture-list>
    </mat-card>

  </div>

</ng-template>

<ng-template #loading>
  <div class="row">
    loading...
  </div>
</ng-template>